//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import Loader from "../loaders/Loader";
	import ArticleLoader from './../loaders/ArticleLoader';
	import ArticlesList from "./../../components/articles/article/ArticlesList";

	export default {
		name: "articles-page",
        //props: ['url', 'top', 'prerended'],
        props: {
			url: String,
            top: Boolean,
            prerended: {
				type: Boolean,
                default: false,
            },
            remove: {
				type: Boolean,
                default: false,
            },
            identifier: {
				type: String,
                default: 'prerended',
            }
        },
		components: {Loader, ArticleLoader, ArticlesList},
        data() {
			return {
				get: null,
				articles: [],
				loaded: false,
                loader: false,
				pagination: null,
                params: {
					top: 'week',
                    order: 'latest',
                },
            }
        },
        created() {
			this.get = this.url;
        },
        mounted() {
			if( !this.prerended ) {
				this.loader = true;
				this.getArticles(1);
				if( this.remove ) {
					$('#' + this.identifier).remove();
				}
			}
        },
        methods: {
			getArticles(page = 1) {
				let url = this.top ? this.get + '?time=' + this.params.top : this.get + '?order=' + this.params.order;
				url = url + '&page=' + page;
                window.Api.get(url).then(response => {
                    if( response.success ) {
                        let articles = response.data.articles;
                        articles.forEach((article) => {
                            this.articles.push(article);
                        });

                        this.pagination = response.paginate;
						this.loaded = true;
					}
					this.loader = false;
                });
            },

            select(param) {
				if( this.top ) {
					this.params.top = param;
                } else {
					this.params.order = param;
                }
                this.articles = [];
				this.loader = true;
                this.getArticles();
            },

            loadMore() {
				this.loader = true;
				let page = this.pagination == null ? 2 : this.pagination.current + 1;
                this.getArticles(page);
            },
        }
	}
